export default "__VITE_ASSET__CjVuaXVE__"